import { Box } from '../../primitives/Box/Box.es.js';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import styled from 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';

const NegativeWrapper = styled(Box)`
    ${({ enableBelow = "md", theme }) => theme.breakpoint(enableBelow, "down")`
        margin-left: calc(var(--maestro-container-padding) * -1);
        margin-right: calc(var(--maestro-container-padding) * -1);
    `};
`;

export { NegativeWrapper };
//# sourceMappingURL=NegativeWrapper.es.js.map
